import * as z from "zod";
import { linxIntegrationSchema } from "./shared";

export const getLinxIntegration = {
  name: "getLinxIntegration" as const,
  input: z.object({}),
  output: z.object({ integration: linxIntegrationSchema.nullable() }),
};
